import indexZh from './zh/index';

export default {
  zh: {
    translation: {
      ...indexZh,
    },
  },
};